var _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartLoad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64.000000pt",
    height: "64.000000pt",
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.10, written by Peter Selinger 2001-2011\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 255 l0 -165 24 0 c15 0 26 -7 29 -19 4 -16 -1 -20 -27 -23 -17 -2 -31 -7 -31 -13 0 -6 85 -11 229 -13 203 -2 231 0 248 14 10 10 18 25 18 36 0 13 8 18 30 18 l30 0 0 95 c0 78 -4 104 -24 148 -29 66 -57 87 -113 87 l-43 0 0 -150 0 -150 -110 0 c-71 0 -110 4 -110 11 0 6 34 9 98 8 l97 -2 3 142 3 141 -176 0 -175 0 0 -165z m320 45 l0 -90 -145 0 -145 0 0 90 0 90 145 0 145 0 0 -90z m100 41 c0 -53 -1 -52 68 -66 l32 -7 0 -74 c0 -65 -2 -74 -18 -74 -10 0 -23 5 -30 12 -6 6 -25 11 -42 10 l-30 -1 0 125 c0 76 4 124 10 124 6 0 10 -22 10 -49z m78 -13 c12 -30 10 -31 -25 -22 -19 5 -23 13 -23 47 0 41 0 41 18 22 10 -11 24 -32 30 -47z m-358 -229 c14 -26 -4 -51 -34 -47 -24 4 -33 33 -16 53 17 21 37 19 50 -6z m314 5 c22 -21 3 -56 -27 -52 -25 3 -34 32 -17 53 16 19 25 19 44 -1z m-81 -34 c5 -19 0 -20 -99 -20 -97 0 -104 1 -104 20 0 19 7 20 99 20 90 0 99 -2 104 -20z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartLoad);
export default __webpack_public_path__ + "static/media/part-load.78d609fe96c89c448a5561adde087c90.svg";
export { ForwardRef as ReactComponent };